import Input from '@/components/form/input';
import {DocumentInputField} from '@/engine/types';
import {useDocumentLocale} from '../../hooks/use-document-locale';
import {FieldProps} from '../../meta-field';

export const InputField = ({field, value, handleChange, handleBlur, handleFocus}: FieldProps<DocumentInputField>) => {
  const {_t} = useDocumentLocale();

  return (
    <Input
      data-testid={`${field.id}_input`}
      max={field.maxValue ?? undefined}
      maxLength={field.maxLength}
      min={field.minValue ?? undefined}
      name={field.id}
      onBlur={handleBlur}
      onChange={event => handleChange(event.target.value)}
      onFocus={handleFocus}
      placeholder={_t(field.placeholder)}
      readOnly={field.readonly}
      required={field.required}
      type={field.type}
      value={value}
    />
  );
};
